import { Page } from "../page";

export class UpdateMSDCRequest extends Page {
  scanId: string | null;
  msdcType: string | null;
  userId: string | null;

  constructor() {
    super();
    this.scanId = null;
    this.msdcType = null;
    this.userId = null;
  }
}
